import { CssBaseline, Toolbar } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import SideBar from './SideBar'
import TopBar from './TopBar'
import Footer from './Footer' // dodany import
import { Outlet } from 'react-router-dom'
import theme from '../../theme'

const Page = () => {
    const drawerWidth = 240;

    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
          <CssBaseline />
          <SideBar width={drawerWidth} />

          <Box sx={{ flexGrow: 1, flex: 1, display: 'flex', flexDirection: 'column', ml: `${drawerWidth}px`, background: theme.palette.background.default }}>
              <TopBar />
              <Toolbar />
              <Box sx={{ p: 3, flexGrow: 1 }}>
                  <Outlet />
              </Box>
              <Footer />
          </Box>
      </Box>
  )
}

export default Page
